import React from 'react';
import {StyleSheet, View} from 'react-native';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import LazyImage from '@/components/basic/image';
import Text from '@/components/basic/text';
import theme from '@/style';
import {MixLottoListItem} from '../result.type';
import {useTranslation} from 'react-i18next';
import dayjs from 'dayjs';
import {ArrowRightIcon} from '@/common-pages/mix-lottery/svg.variable';

const LotteryCard = ({
  item,
  onPress,
}: {
  item: MixLottoListItem;
  onPress?: () => void;
}) => {
  const {t} = useTranslation();

  return (
    <NativeTouchableOpacity
      onPress={onPress}
      style={[
        theme.background.white,
        theme.flex.row,
        theme.flex.centerByCol,
        theme.flex.between,
        styles.card,
      ]}>
      <View style={[theme.flex.flex1, theme.flex.row, theme.flex.centerByCol]}>
        <LazyImage
          imageUrl={item.icon}
          width={40}
          height={40}
          occupancy="transparent"
        />
        <View style={styles.textWrap}>
          <Text
            fontFamily="fontInterBold"
            fontSize={14}
            main
            style={styles.title}>
            {item.lotteryName}
          </Text>
          {!item.isQuick && (
            <Text accent fontSize={12} fontWeight="500" style={styles.date}>
              {t('result-page.label.latestDrawDate')}
              {': '}
              {item.drawTime && item.drawTime > 0
                ? dayjs(item.drawTime * 1000).format('DD-MM-YYYY hh:mm A')
                : '-'}
            </Text>
          )}
        </View>
      </View>
      <View style={styles.arrowWrap}>
        <ArrowRightIcon width={8} height={12} stroke="#A7AFBC" />
      </View>
    </NativeTouchableOpacity>
  );
};

const styles = StyleSheet.create({
  card: {
    borderRadius: 10,
    paddingHorizontal: 14,
    paddingVertical: 12,
    minHeight: 60,
  },
  textWrap: {
    marginLeft: 10,
    flex: 1,
  },
  title: {
    lineHeight: 18,
    letterSpacing: -0.2,
  },
  date: {
    marginTop: 4,
    lineHeight: 14,
  },
  arrowWrap: {
    marginLeft: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default LotteryCard;
